<template>
  <AppConfirm
    title="Confirm changes"
    confirm-label="Save"
    size="slarge"
    @confirm="$emit('confirm')"
    @cancel="$emit('close')"
  >
    This will remove {{ memberName }} from {{ teamName }} and associate them directly to this project and every other project currently inherited from that team.
    You can’t undo this change.
  </AppConfirm>
</template>

<script>
export default {
  name: 'ConfirmTeamMemberToUserConversionDialog',
  props: {
    memberName: {
      type: String,
      required: true
    },
    teamName: {
      type: String,
      required: true
    },
  },
  emits: ['confirm', 'close'],
};
</script>
